// extracted by mini-css-extract-plugin
export default {"lds-ring":"Spinner_lds-ring__3GCTP"};